export default __webpack_public_path__ + "static/oAsxXGqo-1c97a4396a7b5f6fa35c760468205438.svg";